/**
 * MA Signals brand mark — a scientific conversation flowing into a signal.
 * Abstract "M" drawn as a signal waveform with knowledge-node endpoints.
 * Works on light and dark surfaces via currentColor + accent props.
 */
export function SignalMark({ size = 36, wave = "#00E5FF", node = "#20C997", bg = "#0B1F3A", rounded = true }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      {bg && <rect width="48" height="48" rx={rounded ? 12 : 0} fill={bg} />}
      <path
        d="M8 30 L14 30 L19 15 L26 36 L31 22 L34 27 L40 27"
        stroke={wave}
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="30" r="2.6" fill={node} />
      <circle cx="40" cy="27" r="2.6" fill={node} />
    </svg>
  );
}

export function BrandLogo({ size = 34, light = false, showName = true, tagline }) {
  return (
    <span className="flex items-center gap-2.5">
      <SignalMark size={size} bg={light ? "#0B1F3A" : "#0B1F3A"} />
      {showName && (
        <span className="leading-tight text-left">
          <span className={`block font-semibold tracking-tight text-lg ${light ? "text-white" : ""}`}>
            MA Signals<sup className="text-[9px] font-normal align-super">™</sup>
          </span>
          {tagline && (
            <span className={`block text-[9px] tracking-[0.22em] uppercase ${light ? "text-white/50" : "text-muted-foreground"}`}>
              {tagline}
            </span>
          )}
        </span>
      )}
    </span>
  );
}
